import "./Department.scss";
import Container from "../BlockElement/Container/Container";
import { IDepartment } from "../../types/IDepartment";
import Service from "../Service/Service";
import Heading from "../TextElement/Heading/Heading";

export default function Department({ title, services }: IDepartment) {
  return (
    <Container className="department">
      <Heading type="h2" items={[]} htmlFor={""}>{title}</Heading>
      <Container className="department-services">
        {services.map((service, index) => (
          <Service key={index} title={service} />
        ))}
      </Container>
    </Container>
  );
}
